module.exports = __webpack_public_path__ + "static/india_character_home.77270b31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/subdomen/india_character_home.svg
// module id = 527
// module chunks = 35783957827783